module.exports = __webpack_public_path__ + "assets/img/3.248b296d.png";